import { Button, Dropdown, Icons } from '@commenda/kakashi';

import { ComposerControlsHelper } from './composer-controls-helper';
import type { IComposerModeConfig } from './types';

interface ComposerModeMenuProps {
  modeConfig: IComposerModeConfig;
}

/** The mode the next turn runs in: Plan or Agent. */
export const ComposerModeMenu = ({ modeConfig }: ComposerModeMenuProps) => (
  <Dropdown
    align="start"
    side="top"
    sideOffset={8}
    menu={{
      groups: [
        {
          items: ComposerControlsHelper.MODE_OPTIONS.map((option) => ({
            label: option.label,
            onClick: () => modeConfig.onModeChange(option.value),
          })),
        },
      ],
    }}
  >
    <Button variant="tertiary" size="sm">
      {ComposerControlsHelper.getModeName(modeConfig.mode)}
      <Icons.ChevronDown className="size-3" />
    </Button>
  </Dropdown>
);
